import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  REACTIVATE_BUTTON: `${cleanedFilename(__filename)}-reactivate-button`,
};
